import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-3" }
const _hoisted_2 = {
  key: 1,
  "data-qa": "backer-center-section:Skeleton"
}
const _hoisted_3 = {
  key: 1,
  class: "_tar"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_backer_center_preview_skeleton = _resolveComponent("backer-center-preview-skeleton")
  const _component_base_text = _resolveComponent("base-text")
  const _component_icon_base_button = _resolveComponent("icon-base-button")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_box = _resolveComponent("box")
  const _component_icon_link = _resolveComponent("icon-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.title)
      ? (_openBlock(), _createBlock(_component_base_title, {
          key: 0,
          as: "h2",
          level: "h2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.title), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_box, {
      content: !$props.isEmpty,
      class: "_grow-1 _flex"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass($options.stackSeparatedClasses)
        }, [
          (!$props.isLoading)
            ? _renderSlot(_ctx.$slots, "default", { key: 0 })
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                  return _createVNode(_component_backer_center_preview_skeleton, { key: n })
                }), 64 /* STABLE_FRAGMENT */))
              ])),
          ($props.isEmpty && !$props.isLoading)
            ? (_openBlock(), _createBlock(_component_empty_state, {
                key: 2,
                "show-divider": false,
                "data-qa": "empty-state"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_text, { level: "b2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($props.emptyTitle), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_base_text, { level: "b2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($props.emptyDescription), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  ($props.hasEmptyAction)
                    ? (_openBlock(), _createBlock(_component_icon_base_button, {
                        key: 0,
                        tag: "a",
                        "empty-state": "",
                        href: $options.searchUrl,
                        icon: "search",
                        theme: "accent",
                        class: "_mt-3"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.Resources.BackerCenter.UpdatesFeedEmptyStateButtonLabel), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["href"]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */)
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["content"]),
    ($options.isMoreVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_icon_link, {
            href: $props.linkMore,
            icon: "chevron-right",
            "icon-position": "after",
            class: "_tc--accent",
            "data-qa": "backer-center-view-more"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($props.labelMore), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["href"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}